import { ReactNode } from "react"

import styles from "./QuillFilterContainer.module.scss"

export default function QuillFilterContainer(props: { children: ReactNode }) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
